import {gsap} from "../../../../libs/gsap/all.js"
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';

// Constructor
export class GameACrankset extends PIXI.Container {

  constructor(game) {
    super();

    this.animationTimeline = null;
    this.idleAnimationTimeline = null;

    this.animationSpeed = 0;

    this.game = game;

    this.build();
  }

  build() {
    let background = new PIXI.Sprite(PIXI.Texture.from("crankset-background"));
    this.addChild(background);

    this.arrowsWrapper = new PIXI.Container();
    this.arrowsWrapper.alpha = 0;
    this.arrowsWrapper.eventMode = "none";
    this.addChild(this.arrowsWrapper);

    let arrow1 = new PIXI.Sprite(PIXI.Texture.from("crankset-arrow"));
    arrow1.position.set(-75, -250);
    this.arrowsWrapper.addChild(arrow1);

    let arrow2 = new PIXI.Sprite(PIXI.Texture.from("crankset-arrow"));
    arrow2.scale.set(-1);
    arrow2.position.set(75, 250);
    this.arrowsWrapper.addChild(arrow2);

    this.pedalBar1 = new PIXI.Sprite(PIXI.Texture.from("crankset-bar"));
    this.pedalBar1.anchor.set(1, 0.5);
    this.addChild(this.pedalBar1);

    this.pedalWrapper1 = new PIXI.Container();
    this.addChild(this.pedalWrapper1);

    this.pedal1 = new PIXI.Sprite(PIXI.Texture.from("crankset-pedal"));
    this.pedal1.position.set(-this.pedalBar1.width, 0)
    this.pedalWrapper1.addChild(this.pedal1);

    this.gear = new PIXI.Sprite(PIXI.Texture.from("crankset-wheel"));
    this.addChild(this.gear);

    this.pedalBar2 = new PIXI.Sprite(PIXI.Texture.from("crankset-bar"));
    this.pedalBar2.anchor.set(1, 0.5);
    this.addChild(this.pedalBar2);

    this.pedalWrapper2 = new PIXI.Container();
    this.addChild(this.pedalWrapper2);

    this.pedal2 = new PIXI.Sprite(PIXI.Texture.from("crankset-pedal"));
    this.pedal2.position.set(this.pedalBar2.width, 0)
    this.pedalWrapper2.addChild(this.pedal2);

    let middle = new PIXI.Sprite(PIXI.Texture.from("crankset-middle"));
    this.addChild(middle);

    this.idleArrow = new PIXI.Sprite(PIXI.Texture.from("crankset-idle-arrow"));
    this.idleArrow.position.set(-200, -200);
    this.idleArrow.anchor.set(1, 1);
    this.idleArrow.alpha = 0;
    this.idleArrow.eventMode = "none";
    this.addChild(this.idleArrow);

    this.buildAnimation();
    this.buildIdleAnimation();

    this.enable();
  }

  buildAnimation() {
    this.animationTimeline = gsap.timeline({
      defaults: {
        duration: 5,
        ease: "none",
        repeat: -1,
        immediateRender: true,
      },
      paused: false,
      repeat: -1,
    })

    this.animationTimeline.fromTo(this.arrowsWrapper,
      {
        pixi: {
          rotation: 0
        }
      },
      {
        pixi: {
          rotation: 360
        }
      }, 0)

    this.animationTimeline.fromTo(this.pedalBar1,
      {
        pixi: {
          rotation: -45
        }
      },
      {
        pixi: {
          rotation: 315
        }
      }, 0)

    this.animationTimeline.fromTo([this.pedalWrapper1, this.pedalWrapper2],
      {
        pixi: {
          rotation: -45
        }
      },
      {
        pixi: {
          rotation: 315
        }
      }, 0)

    // inverse pedals rotation to cancel the rotation and make them always horizontal
    this.animationTimeline.fromTo([this.pedal1, this.pedal2],
      {
        pixi: {
          rotation: 45
        }
      },
      {
        pixi: {
          rotation: -315
        }
      }, 0)

    this.animationTimeline.fromTo(this.pedalBar2,
      {
        pixi: {
          rotation: 135
        }
      },
      {
        pixi: {
          rotation: 495
        }
      }, 0)

    this.animationTimeline.fromTo(this.gear,
      {
        pixi: {
          rotation: 0
        }
      },
      {
        pixi: {
          rotation: 360
        }
      }, 0)
  }

  buildIdleAnimation() {
    this.idleAnimationTimeline = gsap.timeline({
      defaults: {
        // repeat: -1,
        immediateRender: true,
      },
      // paused: true,
      repeat: -1,
      yoyo: true,
    })

    this.idleAnimationTimeline.fromTo(this.idleArrow,
      {
        pixi: {
          x: -200,
          y: -200,
        }
      },
      {
        pixi: {
          x: -100,
          y: -100,
        },
        duration: 1,
        ease: "sine.inOut"
      }, 0)
  }

  startIdleMode() {
    this.idleAnimationTimeline.progress(0);
    this.idleAnimationTimeline.play();

    gsap.to(this.idleArrow,
      {
        pixi: {
          alpha: 1
        },
        overwrite: "auto",
        duration: 0.5
      })
  }

  stopIdleMode() {
    gsap.to(this.idleArrow,
      {
        pixi: {
          alpha: 0
        },
        overwrite: "auto",
        duration: 0.5,
        onComplete: () => {
          this.idleAnimationTimeline.pause();
          this.idleAnimationTimeline.progress(0);
        }
      })
  }

  enable() {
    this.eventMode = "static";
  }

  disable() {
    this.eventMode = "none";
    this.onRelease();
  }

  onPress() {
    // smoothly accelerate
    gsap.to(this,
      {
        animationSpeed: 1,
        duration: this.game.globalAccelerationDuration,
        ease: this.game.globalAccelerationEasing,
        overwrite: "auto",
        onUpdate: () => {
          this.animationTimeline.timeScale(this.animationSpeed);
        }
      }
    );

    // Show spinning arrows
    gsap.to(this.arrowsWrapper,
      {
        pixi: {
          alpha: 1
        },
        overwrite: "auto",
        duration: 0.25,
      })

    // Make sure the idle arrow is hidden
    this.stopIdleMode();
  }

  // Function to start the main animation loop
  onRelease() {
    // smoothly deccelerate
    gsap.to(this,
      {
        animationSpeed: 0,
        duration: this.game.globalAccelerationDuration,
        ease: this.game.globalAccelerationEasing,
        overwrite: "auto",
        onUpdate: () => {
          this.animationTimeline.timeScale(this.animationSpeed);
        }
      }
    );

    // Hide spinning arrows
    gsap.to(this.arrowsWrapper,
      {
        pixi: {
          alpha: 0
        },
        overwrite: "auto",
        duration: 0.25,
      })
  }

  reset() {
    this.stopIdleMode();

    this.animationSpeed = 0;

    this.animationTimeline.progress(0, true);

    this.idleAnimationTimeline.pause();
    this.idleAnimationTimeline.progress(0, true);
  }

}
